// Replaces SafePipe — sanitizes an HTML string for use with `dangerouslySetInnerHTML`,
// or returns a "trusted" URL for iframes/images. Uses DOMPurify under the hood.
import { useMemo } from 'react';
import DOMPurify from 'dompurify';

export function useSafeHtml(html: string | null | undefined): string {
  return useMemo(() => (html ? DOMPurify.sanitize(html) : ''), [html]);
}

// Lightweight URL allow-list for embed sources (iframe/img/video).
const ALLOWED_PROTOCOLS = ['https:', 'http:', 'data:', 'blob:'];

export function useSafeUrl(url: string | null | undefined): string {
  return useMemo(() => {
    if (!url) return '';
    try {
      const parsed = new URL(url, window.location.origin);
      if (!ALLOWED_PROTOCOLS.includes(parsed.protocol)) return '';
      return parsed.toString();
    } catch {
      return '';
    }
  }, [url]);
}
